import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
import {FilePdfTwoTone} from '@ant-design/icons';

const {Text} = Typography;
const Content = Layout;

const StanWL = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Content style={{background: 'inherit'}}>
          <Text className='BaseText6'>The purpose of this protocol is to make a calibration curve to determine the minimum and maximum range of detection for the aptamers towards the desired protein.<br/> <br/>This protocol wasn’t performed due to lack of time and resources, however it was designed and planned to be performed in the future or if it serves to other iGEM teams for future aptamer’s investigations.</Text>
          <Layout style={{background: 'transparent'}}>
            <Content style={{marginLeft: '50%', transform: 'translateX(-50%)', marginTop: '2vh', width: '60vh', background: 'transparent'}}>
              <Content style={{width: '15vh', marginTop: '-3vh', marginLeft: '54vh', background: 'transparent'}}><p><i>Go to pdf</i></p></Content>
              <a style={{width: 'fit-content', marginLeft: '58vh'}} target='_blank' rel='noopener noreferrer' href='https://static.igem.wiki/teams/4464/wiki/wet-lab/7-calibration-curve-with-elona.pdf'><FilePdfTwoTone style={{fontSize: '8vh'}} twoToneColor='#eb2f96'/></a>
            </Content>
          </Layout>
        </Content>
        <Divider/>
      </Layout>
    </Layout>
  );
};

export default StanWL;
